import { useEffect, useState, useContext } from 'react'
import { useNavigate } from "react-router-dom"
import BwipJs from "@bwip-js/browser"
import { enqueueSnackbar } from 'notistack'

import _ from "lodash"

import { Typography, Button, CircularProgress } from '@mui/material'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'

import { AppContext } from '/providers/app-context'
import { saveAppleModel, saveAppleTemplate, saveGoogleData, setWizardDone, saveScannerConfiguration, saveInstanceData } from "/providers/templates-api"

const StampComplete = ({ setPrevButtonState, setNextButtonState, clientId, templateId, model, template, objectData, classData, scannerData, instanceData }) => {

  const { apiSource, apiKeys, setProcessing, refreshTemplates } = useContext(AppContext)

  const [saved, setSaved] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    setPrevButtonState("hidden")
    setNextButtonState("hidden")

    savePassTemplate()
  }, [])

  const savePassTemplate = async () => {
    // We can remove the wizard fields now...
    let appleTemplate = _.cloneDeep(template)
    template.backFields.map(f => delete f.wizard)

    let googleClass = _.cloneDeep(classData)
    googleClass.textModulesData.map(f => delete f.wizard)
    googleClass.linksModuleData.uris.map(f => delete f.wizard)

    let googleObject = _.cloneDeep(objectData)
    googleObject.textModulesData.map(f => delete f.wizard)
    googleObject.linksModuleData.uris.map(f => delete f.wizard)

    setProcessing(true)

    enqueueSnackbar({ message: 'Fianlising wizard', variant: 'light' })

    await Promise.all([
      saveAppleModel({ apiSource, apiKeys, templateId, appleModel: model }),
      saveAppleTemplate({ apiSource, apiKeys, templateId, appleTemplate }),
      saveGoogleData({ apiSource, apiKeys, templateId, googleClass, googleObject }),
      saveScannerConfiguration({ apiSource, apiKeys, templateId, scannerData }),
      saveInstanceData({apiSource, apiKeys, templateId, instanceData }),
      setWizardDone({ apiSource, apiKeys, templateId }),
      // TODO handle error
    ])

    enqueueSnackbar({ message: 'All done', variant: 'success' })

    setSaved(true)
    setProcessing(false)

    refreshTemplates()
  }

  return saved ? <Saved navigate={navigate} clientId={clientId} templateId={templateId} scannerData={scannerData}/> : <Saving />
}

export default StampComplete

const Saving = () => {
  return (
    <>
      <Typography variant="h3" sx={{ p: 2 }}>Saving your pass template</Typography>
      <Typography sx={{ p: 2 }}>This will just take a moment</Typography>
      <CircularProgress />
    </>
  )
}

const Saved = ({ navigate, clientId, templateId, scannerData }) => {

  const [barcode, setBarcode] = useState(null)
  const [barcodeSVG, setBarcodeSVG] = useState(null)

  const downloadBarcodePng = () => {
    const img = new Image()
    img.src = barcode;
    img.onload = () => {
      // create Canvas
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.width = img.width
      canvas.height = img.height
      ctx.drawImage(img, 0, 0)
      // create a tag
      const a = document.createElement('a')
      a.download = scannerData.title.replace(/[ ]/g, "-") + "signup-barcode.png"
      a.href = canvas.toDataURL('image/png')
      document.body.appendChild(a) // Required for this to work in FireFox
      a.click()
    }
  }

  const downloadBarcodeSvg = () => {
    let svg = _.clone(barcodeSVG)
    //add name spaces.
    if (!svg.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
      svg = svg.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"')
    }
    if (!svg.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
      svg = svg.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"')
    }

    //add xml declaration
    svg = '<?xml version="1.0" standalone="no"?>\r\n' + svg

    const a = document.createElement('a')
    a.download = scannerData.title.replace(/[ ]/g, "-") + "signup-barcode.svg"
    a.href = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg)
    document.body.appendChild(a) // Required for this to work in FireFox
    a.click()
  }

    const barcodeOptions = {
      bcid: 'qrcode',
      scale: 2,
      includetext: false,
      eclevel: "M",
      ecaddchars: 3,
      layers: 8,
      width: 60,
      height: 60,
      padding: 8,
      backgroundcolor: "#ffffff"
    }
  
    useEffect(() => {
      let canvas = document.createElement('canvas')
  
      BwipJs.toCanvas(canvas, { ...barcodeOptions, text: `https://signup.smartix.uk/stamp/${clientId}/${templateId}` })
  
      let barcode = canvas.toDataURL('image/svg')
  
      setBarcode(barcode)
  
      // We also make an SVG version in case anyone wants to download it
      const barcodeSVG = BwipJs.toSVG({ ...barcodeOptions, text: `https://signup.smartix.uk/stamp/${clientId}/${templateId}` })
  
      setBarcodeSVG(barcodeSVG)
    }, [])

  return (
    <>
      <Typography variant="h3" sx={{ p: 2 }}>Wizard complete</Typography>
      <Typography sx={{ p: 2 }}>Your pass template has been saved</Typography>


      <div className="flex flex-row justify-between w-full p-5">
        <div className="mb-5">
          <Typography variant="h5">
            Scan below or <a href={`https://signup.smartix.uk/stamp/${clientId}/${templateId}`} target="_blank">Click here</a> to visit the signup form
          </Typography>
          <img src={barcode} className="mt-5" />
        </div>

        <div>
          <Typography variant="h5">Download signup barcode images</Typography>

          <div className="flex flex-col gap-5 mt-20">
            <Button onClick={downloadBarcodePng}><FileDownloadOutlinedIcon className="mr-5" />Download PNG Barcode</Button>
            <Button onClick={downloadBarcodeSvg}><FileDownloadOutlinedIcon className="mr-5" />Download SVG Barcode</Button>
          </div>
        </div>
      </div>


      <div className="flex flex-row justify-between mb-10">
        <Button variant="outlined" onClick={() => navigate("/templates", { replace: true })}>Go to template list</Button>
        <Button variant="contained" onClick={() => navigate(`/templates/${templateId}/edit`, { replace: true })}>Go to editor</Button>
      </div>
    </>
  )
}  